/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { getHandler, postHandler, stdErrHandlerFactory } from "../../../utils/Requests";
import { AnyAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Effect, OperationSuccess, Pagination, Setter, Setting } from "../../../utils/Interfaces";
import { AxiosResponse } from "axios";

export function modifyGlobalSetting(key: string, newValue: string, dispatch: Dispatch<AnyAction>, doRefresh: Effect) {
    let data = {
        [key]: newValue,
    };

    postHandler(
        "/api/admin/settings/modify",
        data,
        dispatch,
        (response: AxiosResponse<OperationSuccess, any>) => {
            doRefresh();
        },
        stdErrHandlerFactory(dispatch)
    );
}

export function refreshGlobalSettings(
    dispatch: Dispatch<AnyAction>,
    setLoading: Setter<boolean>,
    setGlobalSettings: Setter<Setting[]>
) {
    getHandler(
        "/api/admin/settings/list",
        dispatch,
        (response: AxiosResponse<Pagination<Setting>, any>) => {
            setGlobalSettings(response.data.results);
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
